import { render, staticRenderFns } from "./reg-input.vue?vue&type=template&id=3a9c9114&scoped=true&"
import script from "./reg-input.vue?vue&type=script&lang=js&"
export * from "./reg-input.vue?vue&type=script&lang=js&"
import style0 from "./reg-input.vue?vue&type=style&index=0&id=3a9c9114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c9114",
  null
  
)

export default component.exports